"use client";
import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { isMaintenanceActive } from "@/components/maintenance/flag";
import { SAME_ORIGIN_LOGO } from "@/components/layout/brand-assets";

export const APP_BANNER_DISMISSED_KEY = "sticko:app-banner-dismissed";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.hqinfosystem.sticko.wastickerapps.stickers&referrer=utm_source%3Dweb%26utm_medium%3Dweb%26utm_content%3Dimageclick%26utm_campaign%3Dhomepage";
// Matches the Angular reference: banner is mobile/tablet only. Above this
// width the layout has room for inline promo and the sticky banner would
// just be noise.
const MOBILE_BREAKPOINT_PX = 960;

export function AppDownloadBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    // The maintenance dialog owns the screen — nothing else may appear over it.
    if (isMaintenanceActive()) return;
    if (window.localStorage.getItem(APP_BANNER_DISMISSED_KEY) === "1") return;
    const update = () => {
      setVisible(window.innerWidth < MOBILE_BREAKPOINT_PX);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    setVisible(false);
    try {
      window.localStorage.setItem(APP_BANNER_DISMISSED_KEY, "1");
    } catch {
      // ignore: localStorage may be disabled
    }
  };

  return (
    <div
      data-track-zone="banner"
      data-track-view="app_download_banner"
      className="fixed inset-x-0 bottom-0 z-30 flex justify-center px-3 pb-3"
    >
      <div
        className="rounded-card flex w-full max-w-150 items-center gap-3 px-4 py-3 text-white shadow-(--shadow-card)"
        style={{ background: "linear-gradient(90deg, #7366f9, #6600ff)" }}
        role="region"
        aria-label="Download mobile app"
      >
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={SAME_ORIGIN_LOGO} alt="Sticko" width={40} height={40} className="shrink-0" />
        <p className="flex-1 text-[13px] leading-tight">
          Download our app for the best WhatsApp sticker making experience.
        </p>
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-pill text-brand-700 shrink-0 bg-white px-4 py-1.5 text-[13px] font-semibold hover:bg-white/90"
        >
          Download
        </a>
        <button
          type="button"
          aria-label="Dismiss"
          onClick={dismiss}
          className="-mr-1 shrink-0 rounded-full p-1 text-white/90 hover:bg-white/15"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
